import React from "react";
import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import themes from "../../../assets/theme";
import { H2, PrimaryStyledButton } from "./Styles";
import { navigate } from "@reach/router";
import {
  ProfileBox,
  ProfileContainer,
  ProfileImage,
  DirectorImg,
} from "./BoardOfDirectors";

const useStyles = makeStyles((theme) => ({
  subheading: {
    color: COLORS.BTN_GREEN,
    fontSize: "18px",
    margin: "10px 0 5px 0",
    fontWeight: 600,
  },
  content: {
    fontFamily: themes.fonts.primaryFontBold,
    color: "#293461",
    fontSize: "14px",
  },
}));

function TheManagementTeam(props) {
  const classes = useStyles();

  return (
    <ContainerPage>
      <H2 style={{ textAlign: "center", padding: "60px 0 50px" }}>
        Management Team
      </H2>

      <CenteredProfileContainer>
        <ProfileBox>
          <ProfileImage>
            <ManagementImg
              src={require("../../../assets/images/Rahul Nanuhal.png")}
              alt="Rahul Nanuhal"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Rahul Nanuhal</h4>
            <span className={classes.content}>Co Founder & CEO</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <ManagementImg
              src={require("../../../assets/images/Madhav pudipeddi.jpg")}
              alt="Madhav Pudipeddi"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Madhav Pudipeddi</h4>
            <span className={classes.content}>Co Founder & COO</span>
          </ProfileName>
        </ProfileBox>

        <ProfileBox>
          <ProfileImage>
            <ManagementImg
              src={require("../../../assets/images/maheswari.png")}
              alt="Maheswari Jaganathan"
            />
          </ProfileImage>
          <ProfileName>
            <h4 className={classes.subheading}>Maheswari Jaganathan</h4>
            <span className={classes.content}>Software Development Head</span>
          </ProfileName>
        </ProfileBox>
      </CenteredProfileContainer>

      <PrimaryStyledButton
        style={{ width: "140px", margin: "60px auto 30px", display: "block" }}
        onClick={() => navigate("/management-team")}
      >
        See More
      </PrimaryStyledButton>
    </ContainerPage>
  );
}

export default TheManagementTeam;

const ManagementImg = styled(DirectorImg)``;

const CenteredProfileContainer = styled(ProfileContainer)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 50px;
  justify-content: center;
  justify-items: center;
  max-width: 1400px;
  width: 100%;
  padding: 0 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(260px, 0px));
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(1.8rem, 3vw, 2.5rem);
    padding: 0 30px;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 50px;
  }
`;

const ProfileName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  margin-top: 20px;
`;

const ContainerPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  width: 100%;
`;
